import { Wrapper } from './Styled'

export default function BrandLoading() {
  return <Wrapper />
}
